import useApiClient from '../../Base/Hooks/useApiClient';
import apiClient from '../../../Services/ApiClient';
import moment, { Moment } from 'moment';
import useRestApiClient from '../../Base/Hooks/useRestApiClient';

export default function usePatient() {
	const { displayError, displaySuccess } = useApiClient();
	const { showUnexpectedError } = useRestApiClient();

	const getIsAdult = (
		day: number,
		month: number,
		year: number,
		ageLimit: number = 18,
	) => {
		if (month > 70 && year > 2003) month -= 70;
		else if (month > 50) month -= 50;
		else if (month > 20 && year > 2003) month -= 20;

		const now = new Date();
		const birthDate = new Date(year, month - 1, day);

		let age = now.getFullYear() - birthDate.getFullYear();

		const birthdayThisYear = new Date(
			now.getFullYear(),
			birthDate.getMonth(),
			birthDate.getDate(),
		);
		if (now < birthdayThisYear) {
			age--;
		}

		return age >= ageLimit;
	};

	const checkIsAdultByInsuranceNumber = (
		insuranceNumberValue: string,
		isPrivateWorkplace: boolean = false,
	) => {
		let year = parseInt(insuranceNumberValue.substr(0, 2), 10);
		const month = parseInt(insuranceNumberValue.substr(2, 2), 10);
		const day = parseInt(insuranceNumberValue.substr(4, 2), 10);
		year += year <= parseInt(moment().format('YY')) ? 2000 : 1900;

		const ageLimit: number = isPrivateWorkplace ? 15 : 18;

		return getIsAdult(day, month, year, ageLimit);
	};

	const checkIsAdultByBirthDate = (birthDate: Moment) => {
		const day = birthDate.day();
		const month = birthDate.month();
		const year = birthDate.year();

		return getIsAdult(day, month, year);
	};

	const assignPatientToWorkplace = async (
		workplaceId: string,
		patientId: string,
	) => {
		try {
			const result = await apiClient.post(
				`/workplaces/${workplaceId}/patient/connect/${patientId}`,
				{},
			);
			if (result?.status === 200) {
				displaySuccess(
					'component.assignPatientToWorkplace.confirmationMessage',
				);
			} else {
				showUnexpectedError();
			}
		} catch (e: any) {
			displayError(e);
		}
	};

	const resendInvitationToWorkplace = async (
		workplaceId: string,
		workplaceMemberId: string,
	) => {
		try {
			const result = await apiClient.put(
				`/workplaces/${workplaceId}/patient/${workplaceMemberId}/invitation`,
				{},
			);
			if (result?.status === 200) {
				displaySuccess(
					'component.assignPatientToWorkplace.confirmationMessage',
				);
			} else {
				showUnexpectedError();
			}
		} catch (e: any) {
			displayError(e);
		}
	};

	const unArchivePatient = async ({
		workplaceId,
		patientId,
	}: {
		workplaceId: string;
		patientId: string;
	}) => {
		try {
			const result = await apiClient.post(
				`/workplaces/${workplaceId}/patient/restore/${patientId}`,
				{},
			);
			if (result.status === 200) {
				displaySuccess('component.patient.unArchiveSuccess');
				return true;
			} else {
				showUnexpectedError();
			}
		} catch (e) {
			displayError(e);
		}
		return false;
	};

	return {
		checkIsAdultByInsuranceNumber,
		checkIsAdultByBirthDate,
		assignPatientToWorkplace,
		unArchivePatient,
		resendInvitationToWorkplace,
	};
}
